<div class="admin-user-activities">
  <div class="activities--container">
        <!-- Tabs: Assets | Compute | User action -->
        <div class="activities__tabs-row">
          <div class="activities__tabs">
            <button
              type="button"
              class="activities__tab"
              [class.activities__tab--active]="activeLogType === 'ASSET'"
              (click)="setLogType('ASSET')"
            >
              Assets
            </button>
            <button
              type="button"
              class="activities__tab"
              [class.activities__tab--active]="activeLogType === 'COMPUTE'"
              (click)="setLogType('COMPUTE')"
            >
              Compute
            </button>
            <button
              type="button"
              class="activities__tab"
              [class.activities__tab--active]="activeLogType === 'USER_ACTION'"
              (click)="setLogType('USER_ACTION')"
            >
              User action
            </button>
          </div>
          <button
            type="button"
            class="activities__tab activities__tab--export"
            [disabled]="exportLoading"
            [attr.aria-label]="exportLoading ? 'Exporting report' : 'Export activity report as CSV'"
            (click)="exportActivityReport()"
          >
            {{ exportLoading ? 'Exporting…' : 'Export' }}
          </button>
        </div>

        <!-- Filter Section -->
        <app-filter-panel
          [fields]="filterFields"
          [defaultExpanded]="false"
          (filterChange)="onFilterChange($event)"
          (clearFilters)="onClearFilters()"
        ></app-filter-panel>

        <!-- Table -->
        <app-table
          [columns]="columns"
          [data]="activitiesData"
          [dropdownOpenRowIndex]="openDropdownRowIndex"
          [scrollHeight]="'400px'"
          [loading]="loading"
          [pagination]="pagination"
          [emptyMessage]="emptyMessage"
          [striped]="true"
          [bordered]="true"
          [hoverable]="true"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (sortChange)="onSortChange($event)"
        >
          <!-- Custom Activity Column with Left Border Accent -->
          <ng-template #activityCell let-row>
            <div class="activity-cell" [ngClass]="getActivityClass(row.activity)">
              <span class="activity-text">{{ row.activity }}</span>
            </div>
          </ng-template>
          
          <!-- Custom Action Column (dropdown is rendered in fixed overlay below) -->
          <ng-template #actionCell let-row>
            <div class="action-cell-wrapper">
              <button 
                class="action-btn" 
                appActionDropdownTrigger
                (click)="toggleActionDropdown($event, row)"
                [class.active]="isDropdownOpen(row)"
              >
                <span>Action</span>
              </button>
            </div>
          </ng-template>
        </app-table>
      </div>
</div>

<!-- Fixed overlay: dropdown on top of table (outside scroll container) -->
<div
  *ngIf="dropdownPosition && openDropdownRow"
  class="action-dropdown-overlay"
  [style.top.px]="dropdownPosition.top"
  [style.left.px]="dropdownPosition.left"
  [style.min-width.px]="dropdownPosition.width"
  (click)="$event.stopPropagation()"
>
  <ul class="dropdown-list">
    <li class="dropdown-item">
      <button type="button" class="dropdown-link" (click)="handleAction('view', openDropdownRow)">
        Details
      </button>
    </li>
  </ul>
</div>

<!-- Activity Details Modal -->
<app-tab-modal
  [(visible)]="isModalVisible"
  header="Activity Details"
  [width]="'600px'"
  [height]="'520px'"
  [tabs]="modalTabs"
  defaultTab="activityInfo"
  (onClose)="closeModal()"
></app-tab-modal>

<!-- User Information Tab Content Template -->
<ng-template #userInfoTabContent>
  <div class="user-details-section" *ngIf="selectedActivity">
    <div *ngIf="!userDetails" class="no-data-message">
      No Data Available
    </div>
    <div *ngIf="userDetails">
        <div class="detail-row">
          <div class="detail-label">Name:</div>
          <div class="detail-value">{{ userDetails.name || 'N/A' }}</div>
        </div>
        <div class="detail-row">
          <div class="detail-label">Email:</div>
          <div class="detail-value">{{ userDetails.email || 'N/A' }}</div>
        </div>
        <div class="detail-row">
          <div class="detail-label">Roles:</div>
          <div class="detail-value">
            <ng-container *ngIf="formatService.getHighestRole(userDetails.roles || []) as highestRole; else noRole">
              <span class="roles-container">
                <span class="role-badge">{{ highestRole }}</span>
              </span>
            </ng-container>
            <ng-template #noRole><span>N/A</span></ng-template>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-label">Email Verified:</div>
          <div class="detail-value">{{ userDetails.emailVerified ? 'Yes' : 'No' }}</div>
        </div>
        <div class="detail-row">
          <div class="detail-label">Account Enabled:</div>
          <div class="detail-value">{{ userDetails.account_enabled ? 'Yes' : 'No' }}</div>
        </div>
        <div class="detail-row">
          <div class="detail-label">Created At:</div>
          <div class="detail-value" *ngIf="userDetails.createdAt">
            <span class="date-part">{{ formatService.formatDateOnly(userDetails.createdAt) }}</span>
            <span class="time-part">{{ formatService.formatTimeOnly(userDetails.createdAt) }}</span>
          </div>
          <div class="detail-value" *ngIf="!userDetails.createdAt">N/A</div>
        </div>
      </div>
    </div>
</ng-template>

<!-- Activity Information Tab Content Template -->
<ng-template #activityInfoTabContent>
  <div class="activity-details-section" *ngIf="selectedActivity">
    <div class="detail-row">
      <div class="detail-label">Asset Name:</div>
      <div class="detail-value">{{ selectedActivity.assetName || 'N/A' }}</div>
    </div>
    <div class="detail-row">
      <div class="detail-label">Asset Type:</div>
      <div class="detail-value">{{ formatService.formatAssetType(selectedActivity.assetType) || 'N/A' }}</div>
    </div>
    <div class="detail-row">
      <div class="detail-label">Activity:</div>
      <div class="detail-value">{{ selectedActivity.activity || 'N/A' }}</div>
    </div>
    <div class="detail-row">
      <div class="detail-label">Accessed At:</div>
      <div class="detail-value" *ngIf="selectedActivity.accessedAt">
        <span class="date-part">{{ formatService.formatDateOnly(selectedActivity.accessedAt) }}</span> <span class="time-part">{{ formatService.formatTimeOnly(selectedActivity.accessedAt) }}</span>
      </div>
      <div class="detail-value" *ngIf="!selectedActivity.accessedAt">N/A</div>
    </div>
  </div>
</ng-template>
